import Breadcrumbs from "../../components/Shared/Breadcrumbs/Breadcrumbs";
import { SettingsBreadcrumbs } from "../../configs/breadcrumbNavigation";
import SettingsLayout from "./SettingsLayout";

const SettingsPage = () => {
	return (
		<>
			<Breadcrumbs items={SettingsBreadcrumbs} />
			<div className="p-4 px-6">
				<SettingsLayout />
			</div>
		</>
	);
};

export default SettingsPage;
